import { ClipboardCheck } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function AuditsPage() {
  return (
    <PhaseStubPage
      title="Internal audits"
      phase={5}
      modules={[
        'Audit planning + scheduling',
        'Audit execution with finding capture',
        'Findings → CAPA escalation',
        'Annual audit report export',
      ]}
      icon={ClipboardCheck}
    />
  );
}
